import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStopShareScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStopShareScreen"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM12 10.5859L9.70703 8.29297L8.29297 9.70703L10.5859 12L8.29297 14.293L9.70703 15.707L12 13.4141L14.293 15.707L15.707 14.293L13.4141 12L15.707 9.70703L14.293 8.29297L12 10.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStopShareScreen;
